module.exports = __webpack_public_path__ + "img/6-1.01a939ba.png";